import React from 'react';
import SortableItem from "../../../components/sortable/sortable_item";
import {Avatar, List, ListItemText} from 'material-ui';

class SortableImageList extends React.Component {

    state = {
        items: this.props.items
    };

    onSortItems = (items) => {
        this.setState({
            items: items
        });
        this.props.onImagesSortOrder(items);
    };

    render() {
        const {items } = this.state;
        let listItems = items.map((image, i) => {
            return (
                <SortableItem
                    key={i}
                    onSortItems={this.onSortItems}
                    items={items}
                    sortId={i}>
                        <Avatar src={image.preview} />
                        <ListItemText secondary={image.name} />
                </SortableItem>
            );
        });

        return (
            <List component="nav">
                {listItems}
            </List>
        )
    }
};

export default SortableImageList;


// WEBPACK FOOTER //
// ./src/containers/builder/form/sortable_image_list.js